import { render, staticRenderFns } from "./ServiceContainer.vue?vue&type=template&id=127a5acc"
import script from "./ServiceContainer.vue?vue&type=script&lang=ts"
export * from "./ServiceContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports